<template>
	<router-view></router-view>
</template>
<script>
export default {
	name: 'index',
};
</script>
<style lang="less" scoped></style>
